import { getSpam, getChid } from './utils/tool';
import request from './utils/request';
import { nativeWpkReport } from './utils/wpk';
/**
 * 端内请求接口
 * list: [{ key: '', value: ''}]
 */
export const nativeGetData = async ({ data, url, method, extendSignList = [] }: any, showLog = false) => {
  showLog && console.log('端内加密:nativeGetData:', JSON.stringify({ data, url, method, extendSignList, showLog }));
  let allSpam = await getSpam(extendSignList);
  showLog && console.log('端内加密:allSpam', JSON.stringify(allSpam));
  const chid = getChid();
  // 用于排查问题
  if (data) {
    data.chid = chid;
  }

  const headers = {
    'clt-acs-sign': allSpam?.sign || '',
    'clt-acs-reqt': allSpam?.time || '',
    'clt-acs-wsgnver': allSpam?.wsgnver || '',
    'clt-acs-request-params': allSpam?.params || '',
    'clt-acs-kp': allSpam?.kp || '',
    'clt-acs-ve': allSpam?.ve || '',
    'clt-acs-ut': allSpam?.ut || '',
    'clt-acs-caer': 'tlbe',
  };

  nativeWpkReport('request', {
    c1: chid,
    c2: url,
    w_bl1: JSON.stringify({ data, url, method, extendSignList, showLog }),
    w_bl2: JSON.stringify(headers),
  });

  let content = await request({
    url,
    method,
    data,
    headers,
  });
  return content;
};

/**
 * 客户端加解密
 */
export const nativeEncryptOrDecrypt = async ({ msg, type = 0 }: any, showLog: boolean) => {
  return new Promise((resolve) => {
    // @ts-ignore
    if (window?.ucapi?.invoke) {
      // @ts-ignore
      ucapi.invoke('biz.encryptOrDecrypt', {
        enc: 1, // 加密算法、取值: 1:无线保镖  2: M9 (iOS不支持)
        type: type, // 加密方式、取值: 1:加密      0: 解密
        data: {
          // 加密对象
          key: msg, // key 值、取值可以是任意、字符串、对象均可
        },
        success: function (data: any) {
          showLog && console.log('端内解密:encryptOrDecrypt:success', data, msg);
          resolve(data);
        },
        fail: function (data: any) {
          showLog && console.log('端内解密:encryptOrDecrypt:fail', data, msg);
          resolve(false);
        },
      });
    } else {
      resolve(false);
    }
  });
};
